import { InputIcon } from '@platform/ui-library';
import { FC, useEffect, useState } from 'react';
import { useServices } from '../../hooks';
import './bannerForm.scss';

export const SelectAnchor: FC<any> = ({ context }) => {
  const { appConfigService } = useServices();

  const designId = window.apm.serialized.designId;

  const selectedAnchorKey = 'bannerAnchor';

  const selectedAnchor = context.getConfig(selectedAnchorKey) || '';

  const [anchors, setAnchors] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const getAnchors = async () => {
      const anchors = await appConfigService.getAnchors(designId);

      setAnchors(Object.fromEntries(anchors.map(({ id, name }) => {
        return [id, name];
      })));

    };

    getAnchors();
  }, [selectedAnchor]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    context.setConfig(selectedAnchorKey, newValue);
    const nodeId = context.hasWriteProxy()
      ? context.id
      : context.props.parentComponentID;
    window.apm.updateParentNode(
      context,
      nodeId,
      selectedAnchorKey,
      newValue,
      context.type,
      selectedAnchor
    );
    document.dispatchEvent(new CustomEvent('ev-property-refresh'));
  };

  if (!anchors) {
    return null;
  }

  return (
    <div className="form-component-container">
      <label>Banner Anchor</label>
      <InputIcon
        options={anchors}
        type="select"
        placeholder="- Select a Banner Anchor -"
        onChange={onChange}
        value={selectedAnchor}
      />
    </div>
  );
};
